// @ts-nocheck
document.addEventListener('DOMContentLoaded', () => {
  /**
   * @param {{ item_count: number; total_price: number; }} cart
   */
  function updateShippingProgressBar(cart) {
    const container = document.querySelector('.free-shipping-progress-container');
    const status = document.querySelector('.cart-free-shipping-status');

    if (!container) return;

    if (!cart || cart.item_count === 0) {
      container.style.display = 'none';
      if (status) status.style.display = 'none';
      return;
    }

    container.style.display = 'block';

    const shippingThreshold = parseInt(container.dataset.shippingThreshold || '10000', 10);
    const klarnaThreshold = parseInt(container.dataset.klarnaThreshold || '50000', 10);
    const cartTotal = cart.total_price;

    let target = 'shipping';
    let remainingAmount = 0;

    if (cartTotal < shippingThreshold) {
      target = 'shipping';
      remainingAmount = shippingThreshold - cartTotal;
    } else if (cartTotal < klarnaThreshold) {
      target = 'klarna';
      remainingAmount = klarnaThreshold - cartTotal;
    } else {
      target = 'unlocked_all';
      remainingAmount = 0;
    }

    let progressPercent = 0;
    if (klarnaThreshold > 0) {
      progressPercent = (cartTotal / klarnaThreshold) * 100;
    }

    progressPercent = Math.min(Math.max(progressPercent, 0), 100);

    // Toggle target messages
    const msgShipping = container.querySelector('.msg-shipping');
    const msgKlarna = container.querySelector('.msg-klarna');
    const msgUnlocked = container.querySelector('.msg-unlocked');
    const progressBarFill = container.querySelector('.progress-bar-fill');

    if (msgShipping) msgShipping.style.display = target === 'shipping' ? 'inline' : 'none';


    if (msgKlarna) msgKlarna.style.display = target === 'klarna' ? 'flex' : 'none';
    if (msgUnlocked) msgUnlocked.style.display = target === 'unlocked_all' ? 'inline' : 'none';
    if (status) status.style.display = target === 'unlocked_all' || target === 'klarna' ? 'block': 'none';

    if (progressBarFill) {
      progressBarFill.classList.toggle('is-klarna', target === 'klarna');
      progressBarFill.classList.toggle('is-complete', target === 'unlocked_all');
      progressBarFill.style.width = `${progressPercent}%`;
    }

    // Format remaining amount
    if (remainingAmount > 0) {
      const activeSpan = target === 'shipping' ? msgShipping : msgKlarna;
      const remainingText = activeSpan?.querySelector('.remaining-text');

      if (remainingText) {
        const formattedPrice = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP',
        }).format(remainingAmount / 100);

        remainingText.textContent = formattedPrice;
      }
    }
  }

  // Intercept cart API calls to keep UI in sync
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = args[0];

    if (
      typeof url === 'string' &&
      (url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/remove'))
    ) {
      try {
        const cartData = await (await originalFetch('/cart.js')).json();
        updateShippingProgressBar(cartData);
      } catch (e) {
        console.error('Error updating shipping progress bar:', e);
      }
    }
    return response;
  };
});